import {
  ORG_LOANS_FETCH_REQUESTED,
  ORG_LOANS_FETCHED,
  ORG_LOANS_FETCH_FAILED,
  LOANS_FETCH_REQUESTED,
  LOANS_FETCHED,
  LOANS_FETCH_FAILED,
  LOAN_FETCH_REQUESTED,
  LOAN_FETCHED,
  LOAN_FETCH_FAILED,
  TOGGLE_SPINNER,
  TOGGLE_NOTIFICATION,
} from "utils/constants";
import asyncDispatcher from 'utils/asyncDispatcher';

export const fetchLoansByOrg = (orgId) => (dispatch, getState) => {
  const { api } = getState().app;

  return asyncDispatcher(dispatch, {
    action: api.fetchLoansByOrg(orgId),
    data: { orgId },
    pending: ORG_LOANS_FETCH_REQUESTED,
    success: ORG_LOANS_FETCHED,
    failure: ORG_LOANS_FETCH_FAILED
  });
};

export const fetchLoans = () => (dispatch, getState) => {
  const { api } = getState().app;

  return asyncDispatcher(dispatch, {
    pending: LOANS_FETCH_REQUESTED,
    action: api.fetchLoans(),
    success: LOANS_FETCHED,
    failure: LOANS_FETCH_FAILED
  });
};

export const fetchLoan = (loadId) => (dispatch, getState) => {
  const { api } = getState().app;

  return asyncDispatcher(dispatch, {
    pending: LOAN_FETCH_REQUESTED,
    action: api.fetchLoan(loadId),
    success: LOAN_FETCHED,
    failure: LOAN_FETCH_FAILED
  });
};

export const fetchLoanReminders = () => (dispatch, getState) => {
  const { api } = getState().app;

  return asyncDispatcher(dispatch, {
    pending: LOANS_FETCH_REQUESTED,
    action: api.fetchLoanReminders(),
    success: LOANS_FETCHED,
    failure: LOANS_FETCH_FAILED
  });
};

export const confirmRepayment = (loanScheduleId, status) => (dispatch, getState) => {
  const { api } = getState().app;
  dispatch({type: TOGGLE_SPINNER});

  api.confirmRepayment(loanScheduleId, status)
    .then(resp => {
      dispatch(fetchLoanReminders());
    })
    .then(() => { dispatch({type: TOGGLE_SPINNER}) })
};

export const noteLoanSchedule = (loanScheduleId, note) => (dispatch, getState) => {
  const { api } = getState().app;
  dispatch({type: TOGGLE_SPINNER});
  api.noteLoanSchedule(loanScheduleId, note)
    .then(resp => {
      dispatch(fetchLoanReminders());
    })
    .then(() => { dispatch({type: TOGGLE_SPINNER}) })
};

export const notifyCustomer = (loanScheduleId) => (dispatch, getState) => {
  const { api } = getState().app;
  dispatch({type: TOGGLE_SPINNER});
  api.notifyCustomer(loanScheduleId)
    .then(resp => {
      dispatch(fetchLoanReminders());
    })
    .then(() => { dispatch({type: TOGGLE_SPINNER}) })
};

export const updateLoan = (loanId, payload) => (dispatch, getState) => {
  const { api } = getState().app;
  dispatch({type: TOGGLE_SPINNER});

  api.updateLoan(loanId, payload)
    .then(resp => {
      dispatch({type: TOGGLE_NOTIFICATION, data: { notificationMsg: `${resp.loan.loanNumber} has been updated`}});
      dispatch(fetchLoans());
    })
};



// WEBPACK FOOTER //
// ./src/actions/loans.js